import {InjectionKey} from "vue"

export type TabType = 'order' | 'query' | 'view';


export interface Tab {
  tabId: string
  type: TabType
  label?: string
  count: number
  childTargetPaneId?: string
  parentTabId?: string
  hasUnsavedChanges?: boolean
}

export interface TabView extends Tab {
  type: 'view'
  path: string
  query: Record<string, string | undefined>
  state: Record<string, any>
}

export interface Pane {
  paneId: string
  width: number
  selectedTabId: string | 'new'
  tabs: Tab[]
}

export interface Workspace {
  panes: Pane[]
  /**
   * Active pane refers to the pane that has been most recently iteracted with.
   * It's used by the pane and it's tabs to determine whether they should react to
   * global events such as keyboard events (for keyboard shortcuts).
   */
  activePaneId?: string

  useNewQuickSearch?: boolean

  showSidebar: boolean
  sidebarWidth: number
}

export const stateKey = <InjectionKey<Workspace>>Symbol('stateKey');
export const paneKey = <InjectionKey<Pane>>Symbol('paneKey');

